export enum FaceFrameEnum {
  ONEINCH = '1"',
  '3/4' = '3/4"',
  ICON = 'Icon',
}
